<template>
  <TopNav />
  <div class="container">
    <LeftNav />
    <div class="d-flex connection-middle">
      <div class="filter-div">
        <div
          @click.prevent="activeFilter = ''"
          :class="!activeFilter ? 'category-item-active' : 'category-item'"
        >
          View All
        </div>
        <div
          v-for="(category, index) in categories"
          :key="index"
          @click.prevent="activeFilter = category"
          :class="activeFilter === category ? 'category-item-active' : 'category-item'"
        >
          {{ category }}
        </div>
      </div>

      <div class="d-flex gap-1-rem">
        <div v-for="action in filteredActions" :key="action.id" class="action-item-div">
          <component
            :is="getIconComponent(action.action_key)"
            v-bind="{ name: action.name }"
            class="connection-icon"
          />
          {{ action.name }}
          <span class="action-description">{{ action.short_description }}</span>
          <span class="connection-failed" v-if="checkConnectionFailed(action.action_key)">
            Connection Failed please reconnect to resume service.
          </span>
          <div class="action-buttons">
            <button @click.stop="connectButtonClicked(action)" class="secondary">
              {{
                checkConnectionFailed(action.action_key)
                  ? "Reconnect"
                  : getConnectionStatus(action.action_key)
                  ? "Disconnect"
                  : "Connect"
              }}
            </button>
            <label class="toggle-switch">
              <input type="checkbox" :checked="getConnectionEnabled(action.action_key)" />
              <span class="input-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import LeftNav from '@/components/LeftNav.vue';
import TopNav from '@/components/TopNav.vue';
import { mapGetters } from 'vuex';
import generalService from '@/services/generalService';

export default {
  components: {
    LeftNav,
    TopNav,
  },
  data() {
    return {
      activeFilter: "",
      loadedIcons: {},
    };
  },
  mounted() {
    const icons = require.context('@/components/icons', false, /\.vue$/);
    // Load all icons and store them in loadedIcons
    icons.keys().forEach((filePath) => {
      const iconName = filePath.replace('./', '').replace('.vue', '');
      this.loadedIcons[iconName] = icons(filePath).default;
    });
  },
  computed: {
    ...mapGetters(["actionTypes", "connections"]),
    categories() {
      if (!this.actionTypes) return [];
      const actionValues = Object.values(this.actionTypes || {});
      return actionValues.map((item) => item.category);
    },
    filteredActions() {
      const actionsArray = Object.values(this.actionTypes || {});
      return this.activeFilter
        ? actionsArray.filter(
            (action) => action.category === this.activeFilter && action.category !== "Internal"
          )
        : actionsArray.filter((action) => action.category !== "Internal");
    },
  },
  methods: {
    async connectButtonClicked(action) {
      if (!this.getConnectionStatus(action.action_key) || this.checkConnectionFailed(action.action_key)) {
        const backendUrl = `${process.env.VUE_APP_BACKEND_URL}${action.backend_url}`;
        window.location.href = backendUrl;
      } else {
        let connections = await generalService.deleteConnection(action.action_key);
        this.$store.commit("setConnections", connections.connections);
      }
    },
    connectGmail() {
      const backendUrl = `${process.env.VUE_APP_BACKEND_URL}/connections/gmail`;
      window.location.href = backendUrl;
    },
    connectGoogleDrive() {
      const backendUrl = `${process.env.VUE_APP_BACKEND_URL}/connections/google-docs-drive`;
      window.location.href = backendUrl;
    },
    getConnectionEnabled(actionKey) {
      const connection = this.connections.find((conn) => conn.action_key === actionKey);
      console.log('connection');
      console.log(connection);
      return connection && connection.enabled ? "checked" : false;
    },
    checkConnectionFailed(actionKey) {
      const connection = this.connections.find((conn) => conn.action_key === actionKey);
      return connection && connection.failed;
    },
    getConnectionStatus(actionKey) {
      const connection = this.connections.find((conn) => conn.action_key === actionKey);
      return !!connection;
    },
    getIconComponent(action) {
      if (!action) return null;
      if (!this.actionTypes[action]) return null;
      return this.loadedIcons[this.actionTypes[action].icon];
    },
  },
};
</script>
  
<style scoped>
/* Base Styles */
.connection-failed {
  color: red;
  display: flex;
}

.connection-icon {
  width: 30px;
  margin-bottom: 5px;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
}

.action-description {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: var(--dark-colo-a0);
  padding: 5px 0;
}

.action-item-div {
  background-color: var(--Theme-Color-Secondary-Black);
  border-radius: 5px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(33.33% - 12px);
  max-height: max-content;
}

.category-item,
.category-item-active {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: var(--white-color);
  cursor: pointer;
  padding: 0.5rem;
  box-sizing: border-box;
}

.category-item-active {
  background-color: var(--gray-color-2c);
  border-radius: 5px;
}

.connection-middle {
  flex-grow: 1;
  justify-content: center;
  gap: 1rem;
  margin: 40px 0; /* Reduced gap */
}

/* Container Layout */
.container {
  display: flex;
  gap: 1rem;
}

/* LeftNav Wrapper */
.left-nav-wrapper {
  flex: 0 0 250px; /* Adjust as needed for desktop */
}

/* Filter Sidebar */
.filter-div {
  background-color: var(--Theme-Color-Secondary-Black);
  padding: 1rem;
  border-radius: 1rem;
  min-width: 200px;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
  .left-nav-wrapper {
    /* On mobile, if LeftNav isn't essential, you can hide it or adjust it */
    height: auto;
    padding: 0;
    margin-bottom: 1rem;
  }
  .connection-middle {
    flex-direction: column;
    margin: 20px 0; /* Further reduced gap on mobile */
    justify-content: unset !important;
  }
  .filter-div {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    padding: 0.5rem;
    min-width: auto;
  }
  .category-item,
  .category-item-active {
    flex: none;
    padding: 0.5rem 1rem;
    border-radius: 20px; /* Pill-like appearance */
  }
  .action-item-div {
    flex: 0 0 100%;
    margin-bottom: 1rem;
  }
  .d-flex.gap-1-rem {
    flex-direction: column;
  }
}
</style>
